<template>
  <path d="M11.125 12.875V19H12.875V12.875H19V11.125H12.875V5H11.125V11.125H5V12.875H11.125Z" />
</template>
